/**
 * Free 50g sample auto-add (promo, from 3pm AEST Wed 22/07/2026).
 *
 * Keeps the promo sample in sync with the cart:
 *   - adds it when the cart holds at least one other item
 *   - removes it when the cart is otherwise empty
 *   - clamps it to quantity 1
 *
 * Config is injected by snippets/free-sample-gift.liquid.
 * Deliberately cart-agnostic: custom-cart-drawer.js only loads for B2B, and
 * D2C shoppers are on Rebuy Smart Cart, so this can't live in either one.
 *
 * Append ?gift_preview=1 to run before the start date and turn on logging.
 */
(function () {
  var cfg = window.BrookfarmGift || {};

  // ?gift_preview=1 sticks for the session so it survives navigation.
  var preview = /[?&]gift_preview=1/.test(window.location.search);
  if (preview) sessionStorage.setItem('brookfarm-gift-preview', '1');
  preview = preview || sessionStorage.getItem('brookfarm-gift-preview') === '1';

  function log() {
    if (!preview) return;
    console.log.apply(console, ['[gift]'].concat([].slice.call(arguments)));
  }

  log('loaded. config:', cfg);

  if (!cfg.ready) {
    log(
      'STOPPED: config not ready.',
      'productFound=' + cfg.productFound,
      'variantId=' + cfg.variantId,
      'available=' + cfg.available,
      '-> product is probably not Active / not published to Online Store.'
    );
    return;
  }
  if (cfg.isB2B) return log('STOPPED: B2B customer, promo is D2C only.');

  var now = Date.now();
  if (!preview) {
    if (cfg.startsAt && now < Date.parse(cfg.startsAt)) return;
    if (cfg.endsAt && now > Date.parse(cfg.endsAt)) return;
  }

  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  var syncing = false;
  var queued = false;
  var internal = false;
  var timer = null;

  // Wrap our own cart writes so the fetch/XHR hooks below don't treat them as
  // shopper activity and re-trigger the sync.
  function api(url, body) {
    internal = true;
    return fetch(url, {
      method: 'post',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).finally(function () {
      internal = false;
    });
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (res) {
      return res.json();
    });
  }

  function addGift() {
    log('adding gift, variant', cfg.variantId);
    return api('/cart/add.js', { items: [{ id: cfg.variantId, quantity: 1 }] }).then(function (res) {
      // A 422 here means the 1000 units are gone. The promo ends itself; stay quiet.
      if (!res.ok) log('add failed with', res.status, '- out of stock ends the promo by design.');
      return res;
    });
  }

  function setLine(key, quantity) {
    log('setting gift line to qty', quantity);
    return api('/cart/change.js', { id: key, quantity: quantity });
  }

  function refreshCartUI() {
    // Nudge whichever cart is on screen. Both are optional by design.
    if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.reload === 'function') {
      window.Rebuy.SmartCart.reload();
    }
    document.dispatchEvent(new CustomEvent('brookfarm:gift-updated'));
  }

  function sync() {
    if (syncing) {
      queued = true;
      return Promise.resolve();
    }
    syncing = true;

    return getCart()
      .then(function (cart) {
        var gift = null;
        var hasOther = false;

        cart.items.forEach(function (item) {
          if (item.variant_id === cfg.variantId) {
            gift = item;
          } else {
            hasOther = true;
          }
        });

        log('sync: hasOther=' + hasOther, 'gift=' + (gift ? 'qty ' + gift.quantity : 'none'));

        if (hasOther && !gift) return addGift().then(refreshCartUI);
        if (!hasOther && gift) return setLine(gift.key, 0).then(refreshCartUI);
        if (gift && gift.quantity !== 1) return setLine(gift.key, 1).then(refreshCartUI);
        return null;
      })
      .catch(function (err) {
        // Never let the promo break the cart.
        log('sync error (swallowed):', err);
      })
      .then(function () {
        syncing = false;
        if (queued) {
          queued = false;
          return sync();
        }
      });
  }

  function scheduleSync() {
    clearTimeout(timer);
    timer = setTimeout(sync, 300);
  }

  // Cart writes come from the theme, Rebuy, and other apps, so watch the
  // network rather than binding to any one UI's buttons.
  var nativeFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var promise = nativeFetch.apply(this, arguments);
    if (!internal && CART_WRITE.test(url)) {
      log('cart write seen:', url);
      promise.then(scheduleSync).catch(function () {});
    }
    return promise;
  };

  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (!internal && typeof url === 'string' && CART_WRITE.test(url)) {
      log('cart write seen (xhr):', url);
      this.addEventListener('load', scheduleSync);
    }
    return nativeOpen.apply(this, arguments);
  };

  log('active. running initial sync.');
  scheduleSync();
})();
